import { localize } from "@/i18n/translate";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Wordmark } from "@/components/site/Logo";
import { NetworkGraphic } from "@/components/site/NetworkGraphic";
import { LangSwitch, useContent } from "@/i18n/LangContext";
import { usePortal } from "./i18n";
export const AuthLayout = ({
  children
}) => {
  const {
    p
  } = usePortal();
  const {
    ui
  } = useContent();
  return <div className="grid min-h-screen lg:grid-cols-[minmax(0,5fr)_minmax(0,7fr)]">
      <aside className="on-dark relative hidden overflow-hidden bg-ink p-12 text-paper lg:flex lg:flex-col">
        <Link to="/" aria-label={localize("Swiss Blockchain Alliance")}><Wordmark dark /></Link>
        <div className="pointer-events-none absolute -bottom-24 -right-24 w-[520px] opacity-40 [filter:invert(1)_hue-rotate(180deg)]" aria-hidden="true">
          <NetworkGraphic labels={ui.hero.nodes} ariaLabel="" />
        </div>
        <div className="relative mt-auto max-w-sm">
          <p className="eyebrow !text-zinc-400">{localize(p.area)}</p>
          <p className="mt-4 font-display text-3xl font-bold leading-tight tracking-[-0.02em]">{localize(p.auth.side)}</p>
        </div>
      </aside>
      <main className="flex flex-col px-5 py-8 sm:px-10 lg:px-16">
        <div className="flex items-center justify-between gap-4">
          <Link to="/" className="lg:hidden" aria-label={localize("Swiss Blockchain Alliance")}><Wordmark /></Link>
          <Link to="/" className="hidden items-center gap-2 text-sm font-medium text-ink hover:text-signal lg:inline-flex" data-testid="auth-back-site">
            <ArrowLeft className="h-4 w-4" aria-hidden="true" /> {localize(p.backToSite)}
          </Link>
          <LangSwitch testPrefix="auth-lang" />
        </div>
        <div className="mx-auto my-auto w-full max-w-md py-12">{localize(children)}</div>
      </main>
    </div>;
};
